/*------------------------------------------------
// File Name:PDM_SMS.js
// File Description:PDM_SMS API方法js接口
// Author:zxl
// Create Time:2022/12/05 18:07:17
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _sms: "/PDM_SMS"
}

export default api


//-------------------创建对象-------------------
export function CreatePDM_SMSEntity(parameter) {
    return axios({
        url: api._sms + "/CreatePDM_SMSEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------获取列表-------------------
export function GetPDM_SMSList(parameter) {
    return axios({
        url: api._sms + "/GetPDM_SMSList",
        method: 'post',
        data: parameter
    })
}

//-------------------分页获取列表---------------
export function GetPDM_SMSListByPage(parameter) {
    return axios({
        url: api._sms + "/GetPDM_SMSListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取对象---------------
export function GetPDM_SMSEntity(parameter) {
    return axios({
        url: api._sms + "/GetPDM_SMSEntity",
        method: 'post',
        data: parameter
    })
}


//-------------------保存对象---------------
export function UpdatePDM_SMSEntity(parameter) {
    return axios({
        url: api._sms+ "/UpdatePDM_SMSEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------删掉对象---------------
export function DeletePDM_SMSEntity(parameter) {
    return axios({
        url: api._sms + "/DeletePDM_SMSEntity",
        method: 'post',
        data: parameter
    })
}
